import React from "react";
import { useTranslation } from "react-i18next";

import style from "./styles.module.scss";

const keyI18n = "translations.whoswho.departments";

interface Department {
  acronym: string;
  nameKey: string;
  extension: string;
  personInCharge: string;
  email: string;
}

const departments: Department[] = [
  {
    acronym: "PRODESP",
    nameKey: `${keyI18n}.rows.prodesp`,
    extension: "2018-0172",
    personInCharge: "Marcelo Sampaio Siqueira",
    email: "marcelo.siqueira@pgm.fortaleza.ce.gov.br",
  },
  {
    acronym: "PROFAZ",
    nameKey: `${keyI18n}.rows.profaz`,
    extension: "2180-0711",
    personInCharge: "Gabriel Peixoto Dourado",
    email: "atendimento.da@pgm.fortaleza.ce.gov.br",
  },
  {
    acronym: "PROPAD",
    nameKey: `${keyI18n}.rows.propad`,
    extension: "2018-0167",
    personInCharge: "Eliza Maria Moreira Barbosa",
    email: "edilene.luca@pgm.fortaleza.ce.gov.br",
  },
  {
    acronym: "PROURMA",
    nameKey: `${keyI18n}.rows.prourma`,
    extension: "2018-0198",
    personInCharge: "Pedro Ricardo Pinto da Silva",
    email: "pgm.prourma@pgm.fortaleza.ce.gov.br",
  },
  {
    acronym: "CONGER",
    nameKey: `${keyI18n}.rows.conger`,
    extension: "2018-0154",
    personInCharge: "Paulo Henrique Sá Costa",
    email: "conger@pgm.fortaleza.ce.gov.br",
  },
  {
    acronym: "PROJUD",
    nameKey: `${keyI18n}.rows.projud`,
    extension: "2018-0186",
    personInCharge: "João Afrânio Montenegro",
    email: "joao.montenegro@pgm.fortaleza.ce.gov.br",
  },
  {
    acronym: "CTIGI",
    nameKey: `${keyI18n}.rows.ctigi`,
    extension: "2180-1684",
    personInCharge: "Sérgio Luís Torres Borges",
    email: "sergio.borges@pgm.fortaleza.ce.gov.br",
  },
  {
    acronym: "PROCADIN",
    nameKey: `${keyI18n}.rows.procadin`,
    extension: "2180-1696",
    personInCharge: "Nathan Matias Lopes Soares",
    email: "nathan.soares@pgm.fortaleza.ce.gov.br",
  },
  {
    acronym: "PROLIC",
    nameKey: `${keyI18n}.rows.prolic`,
    extension: "2180-1694",
    personInCharge: "Luís Eduardo Mendes Dantas",
    email: "luis.dantas@pgm.fortaleza.ce.gov.br",
  },
  {
    acronym: "COAFI",
    nameKey: `${keyI18n}.rows.coafi`,
    extension: "2018-0208",
    personInCharge: "Caio Correia Moreira",
    email: "caio.moreira@pgm.fortaleza.ce.gov.br",
  },
  {
    acronym: "PROBSB",
    nameKey: `${keyI18n}.rows.probsb`,
    extension: "",
    personInCharge: " Valéria Moraes Lopes",
    email: "valeria.lopes@pgm.fortaleza.ce.gov.br",
  },
];

export default function DepartmentsTable() {
  const { t } = useTranslation();

  return (
    <div className={style.tableWrapper}>
      <table className={style.table}>
        <thead>
          <tr>
            <th className={`pgm-title-small ${style.acronym}`} scope="col">
              {t(`${keyI18n}.columns.acronym`)}
            </th>
            <th className={`pgm-title-small ${style.fullName}`} scope="col">
              {t(`${keyI18n}.columns.fullName`)}
            </th>
            <th className={`pgm-title-small ${style.extension}`} scope="col">
              {t(`${keyI18n}.columns.extension`)}
            </th>
            <th className={`pgm-title-small ${style.personInCharge}`} scope="col">
              {t(`${keyI18n}.columns.personInCharge`)}
            </th>
            <th className={`pgm-title-small ${style.email}`} scope="col">
              {t(`${keyI18n}.columns.email`)}
            </th>
          </tr>
        </thead>
        <tbody>
          {departments.map((department) => (
            <tr key={department.acronym}>
              <th className={`pgm-body-medium ${style.acronym}`} scope="row">
                {department.acronym}
              </th>
              <td className={`pgm-body-medium ${style.fullName}`}>
                {t(department.nameKey)}
              </td>
              <td className={`pgm-body-medium ${style.extension}`}>
                <a href={`tel:${department.extension.replace(/\D/g, "")}`}>
                  {department.extension}
                </a>
              </td>
              <td className={`pgm-body-medium ${style.personInCharge}`}>
                {department.personInCharge}
              </td>
              <td className={`pgm-body-medium ${style.email}`}>
                <a href={`mailto:${department.email}`}>{department.email}</a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
